import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for all integrations pages.
 * Renders an <Outlet /> for child routes (catalog index, Google Sheets, etc.).
 */
export const Route = createFileRoute('/_dashboard/org/$orgId/integrations')({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
